import { StyleSheet, Platform } from "react-native";

const styles = StyleSheet.create({
  container: {
    marginBottom: 20,
    width: 350,
    justifyContent: "space-between",
    alignSelf: "center",
    paddingHorizontal: 25,
    borderWidth: 0.5,
    borderColor: "#FFF",
    borderRadius: 8,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.25,
    shadowRadius: 6,
    elevation: 4,
  },

  titleSelectionToken: {
    marginTop: 15,
  },

  contentCard: {
    marginTop: 26,
  },

  descriptionElements: {
    borderBottomWidth: 0.2,
    borderColor: "#077A97",
    gap: 10,
    padding: 5,
  },

  titleActives: {
    flex: 0.5,
    fontWeight: "400",
    fontSize: 12,
    color: "#656565",
    textAlign: "left",
    textTransform: "uppercase",
    margin: 0,
  },

  subtitleActives: {
    flex: 0.5,
    fontWeight: "400",
    fontSize: 14,
    color: "#000",
    textAlign: "left",
    alignItems: "left",
    textTransform: "uppercase",
  },

  cardFooter: {
    marginTop: 10,
    marginBottom: 13,
    gap: 20,
  },

  action_buttons_container: {
    fontFamily: "Poppins, sans-serif",
    padding: 10,
    width: 320,
    height: 38,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 4,
    backgroundColor: "#077A97",
    marginVertical: 12,
    alignSelf: "center",
    color: "#fff",
  },

  action_button_text: {
    textTransform: "uppercase",
    color: "#FFF",
    textAlign: "center",
  },

  txtPlataforma: {
    fontWeight: "bold",
    fontSize: 10,
  },

  activeSelector: {
    width: 250,
    fontSize: 16,
    backgroundColor: "#FFFFFF",
    padding: 10,
    alignSelf: "center",
    color: "#000",
    borderWidth: 0.5,
    borderColor: "#077A97",
    borderRadius: 4,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.25,
    shadowRadius: 6,
    elevation: 4,
  },
  activeSelectorDisabled: {
    backgroundColor: "#f0f0f0",
  },

  quantidadeSelos: {
    margin: 0,
    fontSize: 26,
  },
  txtAmount: {
    borderBottomWidth: 0.2,
    borderColor: "#077A97",
    gap: 10,
    padding: 5,
  },
});

export default styles;
